import React, { useEffect, useState } from "react";
import classes from "../../style/Style.module.css";
import SuccessLottieAnimation from "../../Components/Animation/SuccessLottieAnimaton";
import FailedLottieAnimation from "../../Components/Animation/FailedLottieAnimaton";
// import PendingLottieAnimation from "../../Components/Animation/PendingAnimation";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { selectPanNumber } from "../../Store/panNumberSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  ROUTE_CUSTOMER_SUPPORT_SCREEN,
  ROUTE_MOBILE_VERIFICATION,
  ROUTE_SIP_Confirmation_Link,
  ROUTE_BLANK_TEXT_SCREEN,
  ROUTE_DXTER_SCANNING,
} from "../../Routes";
import Toast from "../../Components/ToastMsg/Toast";
import { setAccessToken } from "../../Store/Token/AuthTokenSlice";
import {
  selectTransactionNumber,
  setTransactionNumber,
} from "../../Store/TransactionNoSlice";
import { setMobileNumber } from "../../Store/MobileSlice";
import { selectRefreshToken } from "../../Store/Token/refreshTokenSlice";
import DextersScanning from "./DextersScanning";


const AchEmandateStatus = () => {
  const Navigate = useNavigate();
  const dispatch = useDispatch();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const refreshToken = useSelector(selectRefreshToken);
  const { PaymentURL } = location.state || {};
  const storedToken = useSelector((state) => state.storedToken.accessToken);
  const [custID, setCustID] = useState("");
  const [paymentRefNo, setPaymentRefNo] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const [paymentMsg, setPaymentMsg] = useState("");
  const panNumber = useSelector(selectPanNumber);
  const transactionNumber = useSelector(selectTransactionNumber);
  const [isSuccess, setIsSuccess] = useState(false);
  const [ApiTransaction, setApiTransaction] = useState("");

  const [apiCallsInProgress, setApiCallsInProgress] = useState(3);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (apiCallsInProgress > 3) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [apiCallsInProgress]);

  let ShowToast = false;

  const HandleProceed = async () => {
    try {
      setApiCallsInProgress(apiCallsInProgress + 1);

      const nseGetDexterrTrxnNoresponse = await axios.post(
        "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
        {
          nseGetDexterrTrxnNo: {
            onetime_purchase_input_ref_no: "",
            ach_emandate_registration_unique_no:
              queryParams.get("UniqueRefNoFeed"),
            sip_purchase_input_ref_no: "",
          },
        }
      );
      if (
        nseGetDexterrTrxnNoresponse.data.status === true &&
        nseGetDexterrTrxnNoresponse.data.body.dexterr_transaction_number
      ) {
        // First API call
        const response1 = await axios.post(
          "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
          {
            nsePurchaseTrxnGetDetails: {
              dexterr_transaction_no:
                nseGetDexterrTrxnNoresponse.data.body
                  .dexterr_transaction_number,
            },
          }
        );

        console.log(response1.data, "frist api call");

        if (response1.data.statusCode === 200 && response1.data.body.sip_purchase_processed === "Y" ) {
          setApiTransaction(response1.data.body.dexterr_transaction_no);

          // Second API call
          const GetTokenApi = await axios.post(
            "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
            {
              PrivateAccess: {
                dexterr_transaction_no:
                  response1.data.body.dexterr_transaction_no,
                  country_code: "+91"
              },
            }
          );
          // Second API call was successful
          const accessToken = GetTokenApi.data.data.accessToken;
          dispatch(setAccessToken(accessToken));
          dispatch(
            setTransactionNumber(response1.data.body.dexterr_transaction_no)
          );
          dispatch(setMobileNumber(GetTokenApi.data.data.mobileNumber))

         
          Navigate(ROUTE_DXTER_SCANNING, {
            state: { tokens: { accessToken: storedToken, refreshToken } },
          });
        
        }
        else if (response1.data.statusCode === 200) {
          setApiTransaction(response1.data.body.dexterr_transaction_no);

          // Second API call
          const GetTokenApi = await axios.post(
            "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
            {
              PrivateAccess: {
                dexterr_transaction_no:
                  response1.data.body.dexterr_transaction_no,
                  country_code: "+91"
              },
            }
          );
          // Second API call was successful
          const accessToken = GetTokenApi.data.data.accessToken;
          dispatch(setAccessToken(accessToken));
          dispatch(
            setTransactionNumber(response1.data.body.dexterr_transaction_no)
          );
          dispatch(setMobileNumber(GetTokenApi.data.data.mobileNumber))

          // console.log(GetTokenApi.data, "second api call");

          if (
            response1.data.body &&
            response1.data.body.purchase_type &&
            response1.data.body.purchase_type.includes("Systematic") &&
            response1.data.body.sip_purchase_processed !== "Y"
          ) {
            const response2 = await axios.post(
              "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
              {
                nseGetUmrn: {
                  iin: response1.data.body.iin,
                },
              }
            );

            console.log(response2.data, "second api call");

            // Check if UMRN is not available in the response
            if (!response2.data.body.umrn || response2.data.body.umrn === "") {
              // //////Toast.error(errorMessage);
              Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                state: { reason: "Your SIP Transaction Failed." },
              });
            } else if (
              response2.data.body.umrn ||
              response2.data.body.umrn !== "" ||
              response2.data.body.umrn !== null
            ) {
              // UMRN is available, call SIP API
              const responseSip = await axios.post(
                "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
                {
                  nseSipRegistration: {
                    dexterr_transaction_no:
                      response1.data.body.dexterr_transaction_no,
                    umrn_no: response2.data.body.umrn,
                  },
                }
              );

              console.log(responseSip.data);
              console.log(
                ApiTransaction || transactionNumber,
                "transaction number"
              );

              if (
                responseSip.data.status === true &&
                responseSip.data.statusCode === 200
              ) {
                const {
                  fund_details,
                  total_onetime_purchase_amount,
                  total_sip_purchase_amount,
                  pan,
                  sheet_iin,
                  input_ref_no,
                  umrn_no,
                  sheet_iin_activation_status,
                  purchase_trxn_input_list,
                  sheet_primary_distributor,
                } = responseSip.data.body;
                const sipnseOneTimeSendNSe = await axios.post(
                  "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",

                  {
                    nseSipRegistrationSendNse: {
                      dexterr_transaction_no:
                        transactionNumber ||
                        response1.data.body.dexterr_transaction_no,
                      fund_details: fund_details,
                      total_onetime_purchase_amount:
                        total_onetime_purchase_amount,
                      total_sip_purchase_amount: total_sip_purchase_amount,
                      pan: pan,
                      sheet_iin: sheet_iin,
                      input_ref_no: responseSip.data.body.input_ref_no,
                      umrn_no: responseSip.data.body.umrn_no,
                      sheet_iin_activation_status: sheet_iin_activation_status,
                      purchase_trxn_input_list: purchase_trxn_input_list,
                      sheet_primary_distributor: sheet_primary_distributor,
                    },
                  },
                  {
                    headers: {
                      Authorization: `Bearer ${storedToken}`,
                      "Content-Type": "application/json",
                    },
                  }
                );
                console.log(
                  ApiTransaction || transactionNumber,
                  "transaction number"
                );

                if (
                  sipnseOneTimeSendNSe.data.status === true &&
                  sipnseOneTimeSendNSe.data.statusCode === 200 &&
                  sipnseOneTimeSendNSe.data.body
                    .purchase_trxn_dexterr_reference_unique_no !== "" &&
                  sipnseOneTimeSendNSe.data.body.service_msg === "Success" &&
                  sipnseOneTimeSendNSe.data.body.status === "Success"
                ) {
                  const {
                    status,
                    input_ref_no,
                    umrn_no,
                    purchase_trxn_dexterr_reference_unique_no,
                    dexterr_transaction_no,
                    sip_from_date,
                    sip_to_date,
                    sip_period_day,
                    ach_amt,
                    ach_fromdate,
                    ach_enddate,
                    service_return_msg,
                    service_return_code,
                    service_msg,
                    service_response,
                    iin,
                    iin_activation_status,
                    primary_distributor,
                    purchase_trxn_list,
                    purchase_trxn_api_xml_json_data,
                    purchase_trxn_api_xml_data_dict,
                    purchase_req_xml,
                  } = sipnseOneTimeSendNSe.data.body;
                  console.log("this api call nseSipRegistrationWriteresponse");
                  console.log(
                    sipnseOneTimeSendNSe.data.status,
                    sipnseOneTimeSendNSe.data.body
                      .purchase_trxn_dexterr_reference_unique_no,
                    sipnseOneTimeSendNSe.data.body.service_msg,
                    sipnseOneTimeSendNSe.data.body.status
                  );

                  try {
                    const nseSipRegistrationWriteresponse = await axios.post(
                      "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",

                      {
                        nseSipRegistrationWrite: {
                          status: status,
                          input_ref_no: input_ref_no,
                          umrn_no: umrn_no,
                          purchase_trxn_dexterr_reference_unique_no:
                            purchase_trxn_dexterr_reference_unique_no,
                          dexterr_transaction_no:
                            dexterr_transaction_no || ApiTransaction,

                          sip_from_date: sip_from_date,
                          sip_to_date: sip_to_date,
                          sip_period_day: sip_period_day,
                          ach_amt: ach_amt,
                          ach_fromdate: ach_fromdate,
                          ach_enddate: ach_enddate,
                          service_return_msg: service_return_msg,
                          service_return_code: service_return_code,
                          service_msg: service_msg,
                          service_response: service_response,
                          iin: iin,
                          iin_activation_status: iin_activation_status,
                          primary_distributor: primary_distributor,
                          purchase_trxn_list: purchase_trxn_list,
                          purchase_trxn_api_xml_json_data:
                            purchase_trxn_api_xml_json_data,
                          purchase_trxn_api_xml_data_dict:
                            purchase_trxn_api_xml_data_dict,
                          purchase_req_xml: purchase_req_xml,
                        },
                      },
                      {
                        headers: {
                          Authorization: `Bearer ${storedToken}`,
                          "Content-Type": "application/json",
                        },
                      }
                    );
                    console.log(nseSipRegistrationWriteresponse.StatusCode);


                    // const DexPrchsTrxnUpdateDetails = await axios.post(
                    //   "https://partnerapp.ambrela.money/api/DexterrPurchaseTransactionUpdateDetails",

                    //   {
                    //     dexterr_transaction_no: transactionNumber ||
                    //     response1.data.body.dexterr_transaction_no,
                    //     onetime_purchase_nse_unique_no: "",
                    //     ach_emandate_reg_nse_unique_no: "",
                    //     sip_purchase_nse_unique_no: purchase_trxn_dexterr_reference_unique_no
                    //   },
                    //   {
                    //     headers: {
                    //       Authorization: `Bearer ${storedToken}`,
                    //       "Content-Type": "application/json",
                    //     },
                    //   }

                    // )

                    // if (nseSipRegistrationWriteresponse.StatusCode === 504) {
                    // if(nseSipRegistrationWriteresponse.statusCode !== 200 || nseSipRegistrationWriteresponse.statusCode === 200 || nseSipRegistrationWriteresponse.message === "Endpoint request timed out" )


                    if (
                      //   nseSipRegistrationWriteresponse.StatusCode === 504 || nseSipRegistrationWriteresponse.status === false ||
                      //   nseSipRegistrationWriteresponse.message ===  "Endpoint request timed out" || nseSipRegistrationWriteresponse.message ===  "Internal Server Error"
                      //
                      nseSipRegistrationWriteresponse.StatusCode !== 200
                    ) {
                      Navigate(ROUTE_SIP_Confirmation_Link);
                      setApiCallsInProgress(apiCallsInProgress - 1);
                    }

                    // Navigate(ROUTE_SIP_Confirmation_Link);
                    setApiCallsInProgress(apiCallsInProgress - 1);

                  }
                  catch {
                    console.error("Error in nseSipRegistrationWrite:");
                    // Ignore the error and continue
                    Navigate(ROUTE_SIP_Confirmation_Link);
                  }
                }

                else {
                  Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                    state: { reason: sipnseOneTimeSendNSe.data.errorMessage || "Your SIP Purchase Failed" },
                  });
                }

                // setIsSuccess(true);
                // Navigate(ROUTE_SIP_Confirmation_Link);
              } else {
                setApiCallsInProgress(apiCallsInProgress - 1);

                Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                  state: {
                    reason:
                      responseSip.data.errorMessage ||
                      "Your SIP Purchase Failed",
                  },
                });
              }
            } else {
              setApiCallsInProgress(apiCallsInProgress - 1);

              Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                state: { reason: "Your SIP Transaction Failed." },
              });
            }
          } else {
            setApiCallsInProgress(apiCallsInProgress - 1);

            // //////Toast.error(response1.data.errorMessage || response1.data.message);
            // console.log("this is working");
          }
          setApiCallsInProgress(apiCallsInProgress - 1);
        } else if (
          response1.data.statusCode === 500 &&
          response1.data.status === false
        ) {
          const nseiin_custid = await axios.post(
            "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
            {
              nseIINDetails: {
                cust_id: queryParams.get("CustId"),
                // pan: ,
              },
            }
          );

          if (
            (nseiin_custid.data.status === true &&
              nseiin_custid.data.statusCode === 200 &&
              nseiin_custid.data.body.pan !== "") ||
            nseiin_custid.data.body.pan !== null
          ) {
            const response2 = await axios.post(
              "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
              {
                nseGetUmrn: {
                  iin: queryParams.get("CustId"),
                },
              }
            );
            setApiCallsInProgress(apiCallsInProgress - 1);

            console.log(response2.data, "second api call");

            // Check if UMRN is not available in the response
            if (!response2.data.body.umrn || response2.data.body.umrn === "") {
              // //////Toast.error(errorMessage);
              Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                state: { reason: "Your SIP Transaction Failed." },
              });
            } else if (
              response2.data.body.umrn ||
              response2.data.body.umrn !== "" ||
              response2.data.body.umrn !== null
            ) {
              // UMRN is available, call SIP API
              const responseSip = await axios.post(
                "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
                {
                  nseSipRegistration: {
                    dexterr_transaction_no:
                      response1.data.body.dexterr_transaction_no,
                    umrn_no: response2.data.body.umrn,
                  },
                }
              );

              console.log(responseSip.data);

              if (responseSip.data.statusCode === 200) {
                // setIsSuccess(true);
                Navigate(ROUTE_SIP_Confirmation_Link);
              } else {
                Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                  state: {
                    reason:
                      responseSip.data.errorMessage ||
                      "Your SIP Purchase Failed",
                  },
                });
              }
            } else {
              Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                state: { reason: "Your SIP Transaction Failed." },
              });
            }
          } else {
            Navigate(ROUTE_MOBILE_VERIFICATION);
          }
        } else {
          setApiCallsInProgress(apiCallsInProgress - 1);
          Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
            state: {
              reason:
                response1.data.errorMessage || "Your SIP Transaction Failed.",
            },
          });
          // //////Toast.error(response1.data.errorMessage);
        }
      } else {
        Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
          state: { reason: "Your SIP Transaction Failed." },
        });
      }
    } catch (error) {
      if (
        error.response &&
        (error.response.status === 504 ||
          error.response.message === "Endpoint request timed out")
      ) {
        Navigate(ROUTE_SIP_Confirmation_Link);
      } else {
        Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
          state: { reason: "Your SIP Transaction Failed." },
        });
      }
    }
  };

  useEffect(() => {
    const getCustID = queryParams.get("CustID");
    const getPaymentRefNo = queryParams.get("UniqueRefNoFeed");
    const getPaymentStatus = queryParams.get("Status");
    const getPaymentMsg = queryParams.get("ErrorMsg");

    if (getCustID && getPaymentRefNo && getPaymentStatus) {
      setCustID(getCustID);
      setPaymentRefNo(getPaymentRefNo);
      setPaymentStatus(getPaymentStatus);
      setPaymentMsg(
        getPaymentMsg ||
        (getPaymentStatus === "SUCCESS"
          ? "Payment successful"
          : "Payment failed")
      );
      // const timer = setTimeout(() => {
      //   fetchData();
      // }, 5000);
      // return () => clearTimeout(timer);
    } else {
      if (!ShowToast) {
        ShowToast = true;
        // toast.error("Data is not present in url");
      }
      Navigate(ROUTE_MOBILE_VERIFICATION);
    }
  }, [queryParams]);

  // const timer = setTimeout(() => {
  //   fetchData();
  // }, 5000);

  // return () => clearTimeout(timer);
  // const HandleProceed = () => {
  //   if (isSuccess) {
  //     Navigate(ROUTE_SIP_Confirmation_Link);
  //   } else {
  //     Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
  //       state: { reason: "Your SIP Transaction Failed." },
  //     });
  //   }
  // };
  return (
    <div className={classes.DextersScanning_Main_Container}>
      <div className={classes.LottiePlayer_Payment_Container}>
        {paymentStatus === "SUCCESS" ? (
          <SuccessLottieAnimation className={classes.PaymentStatus} />
        ) : (
          <FailedLottieAnimation className={classes.PaymentStatus} />
        )}
      </div>

      {custID && paymentRefNo && paymentStatus && (
        <div className={classes.Payment_Data_Container}>
          <p className={classes.Payment_value_showing}>
            <span>Customer ID : </span>
            <span>{custID}</span>
          </p>
          <p className={classes.Payment_value_showing}>
            <span>Payment Reference Number : </span>
            <span>{paymentRefNo}</span>
          </p>
          <p className={classes.Payment_value_showing}>
            <span>Payment Status : </span>
            <span>{paymentStatus}</span>
          </p>
          <button
            className={classes.proceed_button}
            onClick={HandleProceed}
          // disabled={!isSuccess}
          >
            Proceed
          </button>
        </div>
      )}
      {isLoading && (
        <div className={classes.overlay}>
          <div className={classes.loading_text}>Please Wait...</div>
        </div>
      )}
      <ToastContainer />
    </div>
  );
};

export default AchEmandateStatus;
